import styled from 'styled-components';

export const SIZE_CONFIG = {
  width: 216,
  square: 32,
  inwards: 8,
};

export const RightClickMenuWrapper = styled.nav`
  pointer-events: auto;
  position: fixed;
  top: ${props => props.top || 0}px;
  left: ${props => props.left || 0}px;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  z-index: 3000;

  border: 1px solid
    ${props => (props.isDark ? 'none' : props.theme.color.wfGrey200)};
  box-shadow: ${props =>
    props.isDark ? 'none' : '0px 2px 8px rgba(0, 0, 0, 0.1)'};
`;

export const RowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  min-width: ${SIZE_CONFIG.square * 2}px;
  width: ${SIZE_CONFIG.width}px;

  background-color: ${props =>
    props.isDark ? props.theme.color.wfBlack : props.theme.color.wfWhite};

  ${props =>
    !props.isTitle
      ? `
    &:hover {
      cursor: ${props.hasAction && 'pointer'};
      background-color: ${
        props.isDark ? props.theme.color.wfGrey900 : props.theme.color.wfGrey100
      };
    }`
      : `
      border-bottom: 1px solid ${
        props.isDark ? props.theme.color.wfGrey400 : props.theme.color.wfGrey600
      };
  `}

  ${props =>
    props.isDark &&
    `
    div > svg {
      path {
        fill: ${props.theme.color.wfWhite};
        stroke: ${props.isTitle && props.theme.color.wfYellow};
        stroke-width: ${props.isTitle && '2px'};
      }
    }

    div > h1, h2, h3, h4, h5, h6, p {
      color: ${
        props.isTitle ? props.theme.color.wfYellow : props.theme.color.wfWhite
      };

      span {
        color: ${props.theme.color.wfGrey500};
      }
    }
  `}
`;

export const BlockWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  order: ${props => (props.last ? 10 : 'initial')};
  min-width: ${SIZE_CONFIG.square}px;
  min-height: ${SIZE_CONFIG.square}px;
`;

export const LabelBlockWrapper = styled.div`
  display: flex;
  justify-content: flex- ${props => (props.extra ? 'end' : 'start')};
  align-items: center;
  min-width: ${SIZE_CONFIG.square * 2}px;
  width: ${props => (props.extra ? 'auto' : '100%')};
  min-height: ${SIZE_CONFIG.square}px;
  padding-left: ${props =>
    props.theme.spacing[!props.hasIconBlock && !props.extra ? 'default' : '0']};
  padding-right: ${props => (props.extra ? props.theme.spacing.small : 0)};
`;

export const SubmenuWrapper = styled.div`
  position: absolute;
  top: ${props =>
    props.invertSubmenuY
      ? -((props.submenuOptionsLength - 1) * SIZE_CONFIG.square + 1)
      : 0}px;
  left: ${props => `${props.invertSubmenuX ? '-' : ''}${SIZE_CONFIG.width}`}px;
  border: 1px solid
    ${props => (props.isDark ? 'none' : props.theme.color.wfGrey200)};
  box-shadow: ${props =>
    props.isDark ? 'none' : '0px 2px 8px rgba(0, 0, 0, 0.1)'};
`;

export const RowDivider = styled.div`
  position: absolute;
  top: ${SIZE_CONFIG.square}px;
  left: 50%;
  width: 88%;
  height: 1px;
  background-color: ${props => props.theme.color.wfGrey200};
  transform: translateX(-50%);
  z-index: 1;
`;

export const TestSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 24rem;
  height: 100%;
  background-color: ${props => props.theme.color.wfGrey100};
`;
